import { OutlinedInput } from '@mui/material';
import { styled } from '@mui/material/styles';

// ----------------------------PWDKOutlinedInput----------------------------------
// filled props is a condition whether the input is filled or not
// filled props expect the input value in boolean
// Demo in login page (pages/index.js)

const PWDKOutlinedInput = styled(OutlinedInput)(({ theme, filled }) => ({
  borderRadius: '6px',
  backgroundColor: filled && theme.palette.grey[7],
  '&.MuiInputBase-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.common.black,
      borderWidth: 'thin',
    },
  },
  [theme.breakpoints.down('sm')]: {
    '& .MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
    },
  },
}));

export default PWDKOutlinedInput;
